import { ref } from 'vue';

export const _toast_log = ref(false)
